import { Component, inject } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { RouterService } from '../../../services';
import { BackButtonComponent } from '../../back-button/back-button.component';

@Component({
  selector: 'app-formly-back-button',
  templateUrl: './formly-back-button.component.html',
  styleUrl: './formly-back-button.component.scss',
  imports: [BackButtonComponent],
})
export class FormlyBackButtonComponent extends FormlyFieldBaseComponent {
  private readonly routerService = inject(RouterService);

  onClick() {
    if (this.props.path) {
      this.routerService.path(this.props.path, this.props.route);
    } else {
      this.routerService.back(this.props.route);
    }
  }
}
